import React from 'react';
import { HiArrowRight } from 'react-icons/hi';

const cards = [
  {
    id: 'about',
    emoji: '👤',
    title: 'About Me',
    description: 'Ex-Strategy Consultant that pivotted to technology. Driven by grit, purpose, and a relentless need to outgrow myself.',
    href: '#about',
    gradient: 'from-blue-500/10 to-indigo-600/10',
    border: 'dark:border-blue-500/20 border-blue-300/40 dark:hover:border-blue-400/50 hover:border-blue-400/60',
    accent: 'text-blue-400',
  },
  {
    id: 'professional-journey',
    emoji: '💼',
    title: 'Professional Journey',
    description: 'Oliver Wyman consultant, CFA candidate, UC Berkeley exchange. Now building full-stack products from scratch.',
    href: '#professional-journey',
    gradient: 'from-violet-500/10 to-purple-600/10',
    border: 'dark:border-violet-500/20 border-violet-300/40 dark:hover:border-violet-400/50 hover:border-violet-400/60',
    accent: 'text-violet-400',
  },
  {
    id: 'projects',
    emoji: '🚀',
    title: 'Projects',
    description: 'Real products solving real problems: Synthesis Intelligence & Pausa.',
    href: '#projects',
    gradient: 'from-purple-500/10 to-blue-600/10',
    border: 'dark:border-purple-500/20 border-purple-300/40 dark:hover:border-purple-400/50 hover:border-purple-400/60',
    accent: 'text-purple-400',
  },
  {
    id: 'life-and-interests',
    emoji: '🌍',
    title: 'Life & Interests',
    description: 'Weightlifting. Books. Biohacking.',
    href: '#life-and-interests',
    gradient: 'from-blue-500/10 to-cyan-600/10',
    border: 'dark:border-cyan-500/20 border-cyan-300/40 dark:hover:border-cyan-400/50 hover:border-cyan-400/60',
    accent: 'text-cyan-400',
  },
];

const SummaryCards = () => {
  return (
    <div
      className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 w-full"
      data-aos="fade-up"
      data-aos-delay="100"
    >
      {cards.map(card => (
        <a
          key={card.id}
          href={card.href}
          className={`group p-6 rounded-2xl border bg-gradient-to-br ${card.gradient} ${card.border}
            transition-all duration-300 hover:-translate-y-1 hover:shadow-lg
            dark:hover:shadow-blue-500/10 hover:shadow-slate-200/50 flex flex-col gap-3`}
        >
          <span className="text-3xl">{card.emoji}</span>
          <div>
            <h3 className="font-bold dark:text-white text-slate-900 mb-1 group-hover:bg-gradient-to-r
              group-hover:from-blue-500 group-hover:to-purple-600 group-hover:bg-clip-text
              group-hover:text-transparent transition-all duration-200">
              {card.title}
            </h3>
            <p className="text-sm dark:text-slate-400 text-slate-600 leading-relaxed">
              {card.description}
            </p>
          </div>
          <div className={`mt-auto flex items-center gap-1 text-xs font-medium ${card.accent}`}>
            View section
            <HiArrowRight size={12} className="group-hover:translate-x-1 transition-transform duration-200" />
          </div>
        </a>
      ))}
    </div>
  );
};

export default SummaryCards;
